<app-calendly-esgreporting-dialog></app-calendly-esgreporting-dialog>
<div class="flex flex-row h-screen items-center">
    <app-desktop-sidebar [selectedItemId]="selectedSidebarItemId" class="mobile:hidden"></app-desktop-sidebar>
    <div class="h-screen p-6 overflow-y-auto w-full flex flex-col mobile:p-2">
        <div class="flex flex-col flex-[1]">
            <app-desktop-topbar pageName="{{ 'shared.pages.services' | transloco }}"
                class="mobile:hidden"></app-desktop-topbar>
            <app-mobile-topbar class="hidden mobile:block" [selectedItemId]="selectedSidebarItemId"></app-mobile-topbar>
            <div class="flex flex-wrap gap-6 items-center mobile:justify-evenly">
                <app-tab-button label="{{ 'services.pv_roof' | transloco }}" link="/services/pv-roof"></app-tab-button>
                <app-tab-button label="{{ 'shared.esg_reporting' | transloco }}" link="/services/esg-reportings"
                    [isActive]="true"></app-tab-button>
                <app-tab-button label="{{ 'shared.green_mobility' | transloco }}"
                    link="/services/green-mobility"></app-tab-button>
            </div>

            <div
                class="flex flex-col w-full gap-5 justify-center text-center mt-10 mobile:mt-4 max-w-ultrawide  rounded-[16px]">
                <!--Choose content type-->
                <div class="w-full rounded-t-[16px] bg-neutral-100 p-2 flex mobile:flex-col">
                    <button
                        class="desktop:flex-[1] mobile:w-full rounded-[16px] p-5 flex flex-col gap-2 justify-center items-center"
                        [ngClass]="selectedTop == 1 ? 'bg-[#FFFFFF] shadow-md' : ''" (click)="changeSelect(1)">
                        <img src="assets/icons/services/bulb.svg" class="w-[24px] h-[24px] drop-shadow"
                            alt="{{ 'shared.icon' | transloco }}">
                        <p class="text-xl mobile:text-base text-black font-bold">{{
                            'services.practices_tab_title' | transloco }}</p>
                    </button>
                    <button
                        class="desktop:flex-[1] mobile:w-full rounded-[16px] p-5 flex flex-col gap-2 justify-center items-center"
                        [ngClass]="selectedTop == 2 ? 'bg-[#FFFFFF] shadow-md' : ''" (click)="changeSelect(2)">
                        <img src="assets/icons/services/leaf.svg" class="w-[24px] h-[24px] drop-shadow"
                            alt="{{ 'shared.icon' | transloco }}">
                        <p class="text-xl mobile:text-base text-black font-bold">{{
                            'services.sustainability_tab_title' | transloco }}</p>
                    </button>
                    <button
                        class="desktop:flex-[1] mobile:w-full rounded-[16px] p-5 flex flex-col gap-2 justify-center items-center"
                        [ngClass]="selectedTop == 3 ? 'bg-[#FFFFFF] shadow-md' : ''" (click)="changeSelect(3)">
                        <img src="assets/icons/services/chart.svg" class="w-[24px] h-[24px] drop-shadow"
                            alt="{{ 'shared.icon' | transloco }}">
                        <p class="text-xl mobile:text-base text-black font-bold">{{
                            'services.benefits_obligations_tab_title' | transloco }}</p>
                    </button>
                </div>

                <!--Content-->
                <!--Practices-->
                <div class="w-full rounded-[16px] p-2 flex gap-5 desktop:flex-wrap mobile:flex-col"
                    *ngIf="selectedTop == 1">
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.customs_agency_support' | transloco }}"
                            tag="{{ 'services.practices_tab_title' | transloco }}" tagTextColor="text-primary font-bold"
                            tagBackgroundColor="bg-primary-100"
                            description="{{ 'services.customs_agency_support_description' | transloco }}" [listItems]="[
                                { icon: 'assets/icons/services/file-primary.svg', desc: 'services.customs_agency_support_point_1'},
                                { icon: 'assets/icons/services/shield-primary.svg', desc: 'services.customs_agency_support_point_2'},
                                { icon: 'assets/icons/services/clock-primary.svg', desc: 'services.customs_agency_support_point_3'},
                                ]"></app-services-subsection-card>
                    </div>
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.regulatory_support_arera_gse_terna' | transloco }}"
                            tag="{{ 'services.practices_tab_title' | transloco }}" tagTextColor="text-primary font-bold"
                            tagBackgroundColor="bg-primary-100"
                            description="{{ 'services.regulatory_support_arera_gse_terna_description' | transloco }}"
                            [listItems]="[
                                { icon: 'assets/icons/services/settings-primary.svg', desc: 'services.regulatory_support_arera_gse_terna_point_1'},
                                { icon: 'assets/icons/services/target-primary.svg', desc: 'services.regulatory_support_arera_gse_terna_point_2'},
                                ]"></app-services-subsection-card>
                    </div>
                </div>

                <!--Sustainability & ESG-->
                <div class="w-full rounded-[16px] bg-[#FFFFFF] p-2 flex gap-5 desktop:flex-wrap mobile:flex-col"
                    *ngIf="selectedTop == 2">
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.sustainability_balance' | transloco }}"
                            tag="{{ 'services.esg' | transloco }}" tagTextColor="text-[#4A9D6D]"
                            tagBackgroundColor="bg-[#F0FDF4] font-bold"
                            description="{{ 'services.sustainability_balance_description' | transloco }}" [listItems]="[
                                { icon: 'assets/icons/services/chart-line-green.svg', desc: 'services.sustainability_balance_point_1'},
                                { icon: 'assets/icons/services/target-green.svg', desc: 'services.sustainability_balance_point_2'},
                                { icon: 'assets/icons/services/file-green.svg', desc: 'services.sustainability_balance_point_3'},
                                ]"></app-services-subsection-card>
                    </div>
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.carbon_footprint_analysis' | transloco }}"
                            tag="{{ 'services.esg' | transloco }}" tagTextColor="text-[#4A9D6D]"
                            tagBackgroundColor="bg-[#F0FDF4] font-bold"
                            description="{{ 'services.carbon_footprint_analysis_description' | transloco }}"
                            [listItems]="[
                            { icon: 'assets/icons/services/heartbeat-green.svg', desc: 'services.carbon_footprint_analysis_point_1'},
                            ]"></app-services-subsection-card>
                    </div>
                </div>

                <!--Benefits & Obligations-->
                <div class="w-full rounded-[16px] bg-[#FFFFFF] p-2 flex gap-5 desktop:flex-wrap mobile:flex-col"
                    *ngIf="selectedTop == 3">
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full" title="{{ 'services.declarations' | transloco }}"
                            tag="{{ 'services.benefits' | transloco }}" tagTextColor="text-[#A162CE]"
                            tagBackgroundColor="bg-[#FAF5FE] font-bold"
                            description="{{ 'services.declarations_description' | transloco }}" [listItems]="[
                                { icon: 'assets/icons/services/file-purple.svg', desc: 'services.declarations_point_1'},
                                { icon: 'assets/icons/services/shield-purple.svg', desc: 'services.declarations_point_2'},
                                ]"></app-services-subsection-card>
                    </div>
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.energy_diagnosis' | transloco }}"
                            tag="{{ 'services.benefits' | transloco }}" tagTextColor="text-[#A162CE]"
                            tagBackgroundColor="bg-[#FAF5FE] font-bold"
                            description="{{ 'services.energy_diagnosis_description' | transloco }}" [listItems]="[
                            { icon: 'assets/icons/services/speed-purple.svg', desc: 'services.energy_diagnosis_point_1'},
                            { icon: 'assets/icons/services/target-purple.svg', desc: 'services.energy_diagnosis_point_2'},
                            ]"></app-services-subsection-card>
                    </div>
                    <div
                        class="desktop:flex-[1] rounded-[16px] p-5 bg-[#FFFFFF] shadow-md flex flex-col gap-2 justify-center items-center">
                        <app-services-subsection-card class="w-full"
                            title="{{ 'services.monitoring_systems' | transloco }}"
                            tag="{{ 'services.benefits' | transloco }}" tagTextColor="text-[#A162CE]"
                            tagBackgroundColor="bg-[#FAF5FE] font-bold"
                            description="{{ 'services.monitoring_systems_description' | transloco }}" [listItems]="[
                        { icon: 'assets/icons/services/heartbeat-purple.svg', desc: 'services.monitoring_systems_point_1'},
                        { icon: 'assets/icons/services/chart-line-purple.svg', desc: 'services.monitoring_systems_point_2'},
                        ]" note="{{ 'services.monitoring_systems_note' | transloco }}"
                            noteTextColor="text-[#A162CE] font-bold"
                            noteBackgroundColor="bg-[#FAF5FE]"></app-services-subsection-card>
                    </div>
                </div>

                <div class="flex w-full justify-center">
                    <div class="h-[50px] w-full max-w-[500px] min-w-[200px]">
                        <app-custom-button buttonText="{{ 'optimization.talk_to_specialist' | transloco }}"
                            backgroundColor="bg-primary" textColor="text-white" borderColor="border-primary"
                            hoverBackgroundColor="hover:bg-primary-1200" fontWeight="font-bold"
                            (buttonClick)="talkToSpecialist()"></app-custom-button>
                    </div>
                </div>
            </div>
        </div>
        <app-custom-footer></app-custom-footer>
    </div>
</div>